"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberUtils = void 0;
const twoDecimals = (value) => {
    if (value === undefined)
        return undefined;
    if (value === null)
        return null;
    return Math.round(value * 100) / 100;
};
const twoDecimalsString = (value) => {
    if (value === null)
        return "";
    let valueAsString = `${value}`;
    let [partBeforeComma, partAfterComma = ""] = valueAsString.split(".");
    while (partAfterComma.length < 2)
        partAfterComma += "0";
    return `${partBeforeComma},${partAfterComma}`;
};
exports.numberUtils = {
    twoDecimals,
    twoDecimalsString,
};
//# sourceMappingURL=numberUtils.js.map